import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import {hasOnlyNonBlockingErrors} from 'notebook/tables/excess/Util';

import {LiveRowMetadata} from '../StructuredTableConstants';

/**
 * Determines whether a table has validation errors that should block other actions (e.g. table submission)
 * using the computedTable and the structured table's live metadata (currently only the live row metadata).
 */
export default function hasBlockingValidationErrors(
  computedTable: Array<Array<EvaluatedCell>>,
  {liveRowMetadataByRow}: {liveRowMetadataByRow?: Array<LiveRowMetadata>} = {}
): boolean {
  for (const [rowIdx, evaluatedRow] of computedTable.entries()) {
    // We should ignore any validation errors if the row is archived.
    if (liveRowMetadataByRow?.[rowIdx]?.archivePurpose != null) {
      continue;
    }
    for (const evaluatedCell of evaluatedRow) {
      if (evaluatedCell.error && !hasOnlyNonBlockingErrors(evaluatedCell.error)) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Counts the number of cells in the table that have blocking validation errors.
 */
export function countBlockingValidationErrors(computedTable: Array<Array<EvaluatedCell>>): number {
  let count = 0;
  for (const evaluatedRow of computedTable) {
    for (const evaluatedCell of evaluatedRow) {
      if (evaluatedCell.error && !hasOnlyNonBlockingErrors(evaluatedCell.error)) {
        count++;
      }
    }
  }
  return count;
}
